<script setup>
import TenantFaqTable from "@frontJs/components/tables/projectManagement/TenantFaqTable.vue";
import ProjectManagementLayout from "@frontJs/layouts/ProjectManagementLayout.vue";
import { Head } from "@inertiajs/vue3";
import PageTitle from "@js/components/titles/PageTitle.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { tenant } = defineProps({
  tenant: {
    type: Object,
    required: true,
  },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
  <Head>
    <title>
      {{ tenant.name }} - {{ t("title.faq") }} -
      {{ t("title.projectManagement") }} -
      {{ t("title.datakepler") }}
    </title>
  </Head>

  <PageTitle>
    {{ t("title.projectManagement") }} - {{ t("title.faq") }} -
    {{ tenant.name }}
  </PageTitle>

  <TenantFaqTable :tenant="tenant" />
</template>
